import { GeoCoverage } from "@/components/public/GeoCoverage"
import { LandingFooter } from "@/components/public/LandingFooter"
import { PublicHeader } from "@/components/public/PublicHeader"
import { Heading, Text } from "@/components/ui/typography"
import { Page } from "@supabank/ui"
import { useTranslation } from "react-i18next"

export default function CoveragePage() {
  const { t } = useTranslation("marketing")
  
  return (
    <Page data-ux-contract="canon" role="main" className="bg-background text-foreground">
      {/* Unified PublicHeader component */}
      <PublicHeader />

      <main className="space-y-0" id="main">
        <div className="py-12 sm:py-16 md:py-20">
          <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <div className="mb-8 sm:mb-12 text-center">
              <Heading level={1} className="mb-4">
                {t("geoCoverage.headline")}
              </Heading>
              <Text variant="lg" color="muted" className="max-w-2xl mx-auto">
                {t("geoCoverage.headlineSubtext")}
              </Text>
            </div>
          </div>
          <GeoCoverage id="coverage" />
        </div>
      </main>

      <LandingFooter />
    </Page>
  )
}
